import { isNull, isUndefined } from "lodash";
import { axiosDelete, axiosFileUpload, axiosGet, axiosPatch, axiosPost, axiosPut } from "utils/APIHelper";
import { HTTP_METHOD, buildQueryString, handleResponse } from "./ServiceHelper";

export const apiRequest = async (
  serviceDetails: any,
  data: any,
  thunkApi: any,
  segments?: (string | number)[],
  queryParams?: any,
  axiosOptions?: Record<string, any>
) => {
  const axiosMethodMap: Record<string, Function> = {
    GET: axiosGet,
    PUT: axiosPut,
    POST: axiosPost,
    PATCH: axiosPatch,
    DELETE: axiosDelete,
    UPLOAD: axiosFileUpload
  };

  const fullPath =
    segments && segments.length > 0 ? `${serviceDetails.path}/${segments.join("/")}` : serviceDetails.path;

  const finalUrl =
    isUndefined(queryParams) || isNull(queryParams) ? fullPath : `${fullPath}?${buildQueryString(queryParams)}`;

  const axiosFn = axiosMethodMap[serviceDetails.method];
  const response =
    serviceDetails.method === HTTP_METHOD.GET
      ? await axiosFn(finalUrl, serviceDetails.serviceType)
      : await axiosFn(finalUrl, serviceDetails.serviceType, data, axiosOptions);
  return handleResponse(response, thunkApi);
};
